import(/* webpackMode: "eager" */ "/app/src/app/(fullProviders)/error.tsx");
